export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11808.9c1712a1.jpg";